
export enum SupportedLanguage {
    EN = 'EN',
    CN = 'CN',
}

export interface ApiGetTechTopicRequest {
    input: string;
    source_lang: SupportedLanguage | null;
    target_lang: SupportedLanguage | null;
    task_id: string;
    current_step: string;
}

export interface ApiGetTechTopicResponse {
    tech_topic: string;
}

export const GetTechTopic = Symbol('GetTechTopic');

export interface GetTechTopic {
    getTechTopic(data: ApiGetTechTopicRequest): Promise<ApiGetTechTopicResponse>;
}